import $ from 'jquery';
import _ from 'lodash';
import uuid from 'uuid';

import { userinfo } from './userinfo';
import { ui } from './ui';
import { API } from '../../utilities/constants';
import AuthProvider, { needTokenUpdate } from '../../utilities/authProvider';
import SessionStorageService from '../../services/utilities/SessionStorageService';

function _api() {
  this.api_url = `${API.endpoint}/api/private/`;
}

_api.prototype.getUrl = function(path, param) {
  var query = param ? `?${decodeURIComponent($.param(param))}` : '';
  return this.api_url + path + query;
};

_api.prototype.withToken = async function(options) {
  let token = SessionStorageService.getToken();
  if (_.isEmpty(token)) {
    await AuthProvider.instance.redirectLoginPage();
  }

  if (needTokenUpdate(token)) {
    token = await AuthProvider.instance.silentTokenUdate();
  }

  options.headers = {
    Authorization: `Bearer ${token}`,
    ['X-API-REQUEST-ID']: uuid.v4(),
  };

  return options;
};

// ユーザー情報取得
_api.prototype.getUserProfiles = async function() {
  console.log('api.js', 'getUserProfiles');
  var url = this.getUrl('user_profiles');
  return $.ajax(
    await this.withToken({
      type: 'GET',
      url,
      cache: false,
      dataType: 'json',
      async: false,
      error() {},
    })
  );
};

// 現場情報取得
_api.prototype.getFieldInfo = async function(fieldId) {
  // console.log('api.js', 'getFieldInfo');
  var url = this.getUrl(`fields/${fieldId}`);
  return $.ajax(
    await this.withToken({
      type: 'GET',
      url,
      cache: false,
      dataType: 'json',
      async: false,
      error() {},
    })
  );
};

// 場所一覧取得
_api.prototype.getPlace = async function() {
  // console.log('api.js', 'getPlace');
  var url = this.getUrl('construction_placement_places/list', {
    field_id: userinfo.getFieldId(),
    company_branch_id: userinfo.getCompanyBranchId(),
  });
  return $.ajax(
    await this.withToken({
      type: 'GET',
      url,
      cache: false,
      dataType: 'json',
      async: false,
      error() {},
    })
  );
};

// 場所更新
_api.prototype.updatePlace = async function(placeId, place) {
  // console.log('api.js', 'updatePlace');
  var url = this.getUrl(`construction_placement_places/${placeId}`);
  return $.ajax(
    await this.withToken({
      type: 'PATCH',
      url,
      dataType: 'json',
      data: place,
      error() {},
    })
  );
};

// 部品グループ取得
_api.prototype.getPartsGroup = async function() {
  // console.log('api.js', 'getPartsGroup');
  var url = this.getUrl('construction_placement_part_groups/list', {
    field_id: userinfo.getFieldId(),
    company_branch_id: userinfo.getCompanyBranchId(),
  });
  return $.ajax(
    await this.withToken({
      type: 'GET',
      url,
      cache: false,
      dataType: 'json',
      error() {},
    })
  );
};

// 部品グループ追加
_api.prototype.addGroup = async function(grp) {
  // console.log('api.js', 'addGroup');
  var url = this.getUrl('construction_placement_part_groups', {
    field_id: userinfo.getFieldId(),
    company_branch_id: userinfo.getCompanyBranchId(),
  });
  return $.ajax(
    await this.withToken({
      type: 'POST',
      url,
      cache: false,
      data: JSON.stringify(grp),
      contentType: 'application/json',
      error() {},
    })
  );
};

// 部品グループ編集
_api.prototype.editGroup = async function(groupId, grp) {
  // console.log('api.js', 'editGroup');
  var url = this.getUrl(`construction_placement_part_groups/${groupId}`);
  return $.ajax(
    await this.withToken({
      type: 'PATCH',
      url,
      cache: false,
      data: JSON.stringify(grp),
      contentType: 'application/json',
      error() {},
    })
  );
};

// 部品グループ削除
_api.prototype.deleteGroup = async function(groupId) {
  // console.log('api.js', 'deleteGroup');
  var url = this.getUrl(`construction_placement_part_groups/${groupId}`);
  return $.ajax(
    await this.withToken({
      type: 'DELETE',
      url,
      cache: false,
      contentType: 'application/json',
      error() {},
    })
  );
};

// 部品取得
_api.prototype.getParts = async function(groupId) {
  // console.log('api.js', 'getParts', groupId);
  var url = this.getUrl('construction_placement_parts/list', {
    construction_placement_part_group_id: groupId,
  });
  return $.ajax(
    await this.withToken({
      type: 'GET',
      url,
      cache: false,
      dataType: 'json',
      error() {
        ui.showPopupMessage('部品の取得に失敗しました');
      },
    })
  );
};

// 部品追加(画像保存あり)
_api.prototype.addParts = async function(groupId, file) {
  // console.log('api.js', 'addParts');
  var url = this.getUrl('construction_placement_parts', {
    construction_placement_part_group_id: groupId,
  });
  var fnm = file.name;
  var reg = /(.*)(?:\.([^.]+$))/;
  var nm = fnm.match(reg)[1];
  var form = new FormData();
  form.append('name', nm);
  form.append('image', file);
  return $.ajax(
    await this.withToken({
      type: 'POST',
      url,
      processData: false,
      dataType: 'json',
      cache: false,
      data: form,
      contentType: false,
      error() {
        ui.showPopupMessage('部品の追加に失敗しました');
      },
    })
  );
};

// 部品 編集
_api.prototype.editParts = async function(parts) {
  // console.log('api.js', 'editParts');
  var url = this.getUrl(`construction_placement_parts/${parts.id}`);
  return $.ajax(
    await this.withToken({
      type: 'PATCH',
      url,
      cache: false,
      data: JSON.stringify(parts),
      contentType: 'application/json',
      error() {
        ui.showPopupMessage('部品名の編集に失敗しました');
      },
    })
  );
};

// 部品 削除
_api.prototype.deleteParts = async function(partsId) {
  // console.log('api.js', 'deleteParts');
  var url = this.getUrl(`construction_placement_parts/${partsId}`);
  return $.ajax(
    await this.withToken({
      type: 'DELETE',
      url,
      cache: false,
      contentType: 'application/json',
      error() {
        ui.showPopupMessage('部品の削除に失敗しました');
      },
    })
  );
};

// 日付一覧取得
_api.prototype.getDatelist = async function(prm) {
  // console.log('api.js', 'getDatelist');
  var url = this.getUrl(
    `fields/${userinfo.getFieldId()}/work_dates/construction_placement_date_list`,
    prm
  );

  return $.ajax(
    await this.withToken({
      type: 'GET',
      url,
      contentType: 'application/json',
      error() {},
    })
  );
};

// 日付一覧取得(同期処理))
_api.prototype.getWorkDatelist = async function(fieldId, param) {
  // console.log('api.js', 'getWorkDatelist');
  fieldId = fieldId || 0;
  var url = this.getUrl(`fields/${fieldId}/work_dates`, param);
  return $.ajax(
    await this.withToken({
      type: 'GET',
      url,
      async: false,
      contentType: 'application/json',
      error() {},
    })
  );
};

// 日付ごとキャンバス一覧取得
// _api.prototype.getStaticCanvas = function(param) {
//   console.log('api.js', 'getStaticCanvas');
//   var url = this.api_url + 'canvas/get';
//   return $.ajax(
//     this.withToken({
//       type: 'POST',
//       url: url,
//       data: JSON.stringify(param),
//       contentType: 'application/json',
//       error: function() {},
//     })
//   );
// };

// 画像追加
_api.prototype.uploadImage = async function(file, placeId) {
  // console.log('api.js', 'uploadImage');
  var url = this.getUrl('construction_placement_canvasimages/image', {
    field_id: userinfo.getFieldId(),
    company_branch_id: userinfo.getCompanyBranchId(),
    place_id: placeId,
  });
  var form = new FormData();
  form.append('image', file);
  return $.ajax(
    await this.withToken({
      type: 'POST',
      url,
      processData: false,
      dataType: 'json',
      data: form,
      contentType: false,
      error() {
        ui.hideLoaderBg('');
        ui.showPopupMessage('画像のアップロードに失敗しました。');
      },
    })
  );
};

// 背景追加
_api.prototype.uploadBgImage = async function(file, placeId) {
  // console.log('api.js', 'uploadBgImage');
  const url = this.getUrl('construction_placement_canvasimages/background', {
    field_id: userinfo.getFieldId(),
    company_branch_id: userinfo.getCompanyBranchId(),
    place_id: placeId,
  });
  const form = new FormData();
  form.append('image', file, file.name);
  return $.ajax(
    await this.withToken({
      type: 'POST',
      url,
      processData: false,
      dataType: 'json',
      data: form,
      contentType: false,
      error() {
        ui.hideLoaderBg('');
        ui.showPopupMessage('画像のアップロードに失敗しました。');
      },
    })
  );
};

export const api = new _api();



// WEBPACK FOOTER //
// ./src/canvas/common/api.js